import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../services/wrapper-http-service';
import { Observable, shareReplay } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SvgIconService {
  svgIconMap: Map<string, Observable<SafeHtml>> = new Map<string, Observable<SafeHtml>>();

  constructor(private http: WrapperHttpService, private sanitizer: DomSanitizer) {}

  getSvgIcon(svgPath: string): Observable<SafeHtml> {
    return this.http.get<string>(svgPath, { responseType: 'text' }).pipe(
      map((svg: string) => this.sanitizer.bypassSecurityTrustHtml(svg)),
      shareReplay(1),
    );
  }
}
